import { uint32, uint8 } from '../../utils';
import { CompressMethod } from '../../xmlConvert/compiler';

const LreConfig = {
  // L61
  RLEReversed: {
    defaultBlockBytes: 4,
    REPEAT_THRESHOLD: 5,
    smallerPrefix: 0x80,
    biggerPrefix: 0x00
  },
  // L67
  RLE: {
    defaultBlockBytes: 4,
    REPEAT_THRESHOLD: 3,
    smallerPrefix: 0x00,
    biggerPrefix: 0x80
  }
};

export function encode(
  originBin: any,
  compressMethod: CompressMethod = 'RLE',
  colorFormatByte = 4
) {
  // L61 与 L67 相反
  const { defaultBlockBytes, REPEAT_THRESHOLD, smallerPrefix, biggerPrefix } =
    LreConfig[compressMethod];
  const blockBytes = colorFormatByte || defaultBlockBytes;

  function arrayEquals(a: [], b: []) {
    return a.length === b.length && a.every((val, index) => val === b[index]);
  }

  function getRepeatCount(bin: any) {
    if (compressMethod === 'RLE') {
      if (bin.length < blockBytes) return 0;
      const start = bin.subarray(0, blockBytes);
      let index = 1,
        repeatCount = 1;

      for (; repeatCount < 128 && index < bin.length; repeatCount++, index++) {
        const value = bin.subarray(
          index * blockBytes,
          (index + 1) * blockBytes
        );
        if (!arrayEquals(start, value)) break;
      }
      return repeatCount;
    } else {
      if (bin.length < blockBytes) return 0;
      const start = bin.subarray(0, blockBytes);
      let index = 0,
        repeatCount = 0;
      while (true) {
        const value = bin.subarray(index, index + blockBytes);
        if (arrayEquals(start, value)) {
          repeatCount++;
          if (repeatCount === 127) break;
        } else {
          break;
        }
        index += blockBytes;
        if (index > bin.length) break;
      }
      return repeatCount;
    }
  }
  function getNonRepeatCount(bin: any) {
    if (compressMethod === 'RLE') {
      if (bin.length < blockBytes) return 0;
      let lastIsRepeTition = false;
      let nonRepeatCount = 1,
        index = 1;
      let start = bin.subarray(0, blockBytes);

      for (
        ;
        nonRepeatCount < 128 && index < bin.length;
        nonRepeatCount++, index++
      ) {
        const value = bin.subarray(
          index * blockBytes,
          (index + 1) * blockBytes
        );
        if (arrayEquals(start, value)) {
          if (lastIsRepeTition) {
            nonRepeatCount -= 2;
            break;
          }
          lastIsRepeTition = true;
          continue;
        }
        start = value;
        lastIsRepeTition = false;
      }
      return nonRepeatCount;
    } else {
      if (bin.length < blockBytes) return 0;
      let preValue = bin.subarray(0, blockBytes);
      let index = 0,
        nonRepeatCount = 0,
        repeatCount = 0;
      while (true) {
        const value = bin.subarray(index, index + blockBytes);
        if (arrayEquals(preValue, value)) {
          repeatCount++;
          if (repeatCount > REPEAT_THRESHOLD) break;
        } else {
          preValue = value;
          nonRepeatCount += 1 + repeatCount;
          repeatCount = 0;
          if (nonRepeatCount >= 127) {
            //limit max repeat count to max value of signed char.
            nonRepeatCount = 127;
            break;
          }
        }
        index += blockBytes; // move to next position
        if (index >= bin.length) {
          // data end
          nonRepeatCount += repeatCount;
          break;
        }
        if (index > bin.length) break;
      }
      return nonRepeatCount;
    }
  }
  let index = 0;
  let outBin = Buffer.alloc(0);
  while (index < originBin.length) {
    const repeatCount = getRepeatCount(originBin.subarray(index));
    if (repeatCount === 0) break;
    else if (repeatCount < REPEAT_THRESHOLD) {
      const nonRepeatCount = getNonRepeatCount(originBin.subarray(index));
      const npc =
        compressMethod === 'RLE' ? nonRepeatCount - 1 : nonRepeatCount;

      const controlByte = uint8(npc | smallerPrefix);
      const infoByte = originBin.subarray(
        index,
        index + nonRepeatCount * blockBytes
      );
      outBin = Buffer.concat([outBin, controlByte, infoByte]);

      index += nonRepeatCount * blockBytes;
    } else {
      const rpc = compressMethod === 'RLE' ? repeatCount - 1 : repeatCount;
      const controlByte = uint8(rpc | biggerPrefix);
      const infoByte = originBin.subarray(index, index + blockBytes);
      outBin = Buffer.concat([outBin, controlByte, infoByte]);

      index += repeatCount * blockBytes;
    }
  }
  const magicWord = uint32(0x5aa521e0);

  const len_orig = originBin.length;
  const headerBin = uint32(blockBytes | (len_orig << 4));
  const encodeBin = Buffer.concat([magicWord, headerBin, outBin]);
  return encodeBin;
}
